import React from "react";

const BottomFooter = () => {
  return (
    //bottom-footer bg-color-one py-8
    <div className="bottom-footer bg-light-grey py-8">
      <div className="container container-lg">
        <div className="bottom-footer__inner flex-between flex-wrap gap-16 py-16">
          <p className="bottom-footer__text ">
            Dhofar Global © 2025. All Rights Reserved{" "}
          </p>
          <div className="flex-align gap-8 flex-wrap">
            <span className="text-heading text-sm">We Are Accepting</span>
            <img
              style={{ height: "40px", width: "100px" }}
              src="/assets/images/logo/mas_visa.webp"
              alt=""
            ></img>
          </div>
        </div>
      </div>
    </div>
  );
};

export default BottomFooter;
